import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { groupSameItems } from "../../helpers/ditsMenuItemHelper";
import { SessionMenuItemsRow } from "./SessionMenuItemsRow";

interface Props {
  canDelete: boolean;
}

export const SessionMenuItems = ({ canDelete }: Props) => {
  const ditsMenuItems = useSelector((state: RootState) => state.session.menuItems);

  const groupedItems = groupSameItems(ditsMenuItems);

  if(groupedItems.length <= 0) return null;

  return <>{groupedItems.map((groupItem) => {
    return <SessionMenuItemsRow 
      key={groupItem.key}
      canDelete={canDelete} 
      groupItem={groupItem}
      />
  })}
  </>
};